<!-- Product Widget -->
<div *ngIf="products" class="widget widget-featured-products">
  <div class="flex justify-between items-center mb-4">
    <h3 class="text-2xl font-serif text-gold">{{ widgetTitle }}</h3>
    <a class="text-gold font-serif text-lg hover:text-gold-dark transition duration-300" routerLink="/products">
      See More <span class="text-xl">→</span>
    </a>
  </div>
  <div class="flex overflow-x-auto space-x-4 pb-4 scroll-smooth sm:grid sm:grid-cols-3 lg:grid-cols-4 sm:gap-4 w-full max-w-6xl mx-auto p-2 sm:p-4" #productGrid>
    <app-my-item-product
      *ngFor="let product of products"
      [product]="product"
      [displayMode]="'grid'"
    >
    </app-my-item-product>


  </div>
</div>
